import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    if (state) {
      Object.assign(state, state.getDefaultState());
    }
  },
  setBalance: set("balance"),
  setBalanceOperations: set("balanceOperations"),
  setBalanceNotFound: set("balanceNotFound"),
  setBalanceError: set("balanceError"),
  setLoading: set("loading"),
  setPartners: set("partners"),
  setPartner: set("partner"),
  setBankAccounts: set("bankAccounts"),
  setBankAccount: set("bankAccount"),
  setStatus: set("status"),
  setFilter: set("filter"),
};
